import { formatCompact } from "@/lib/format";

interface AvgViewsColumnCellProps {
  averageViews: number | undefined;
}

export default function AvgViewsColumnCell({
  averageViews,
}: AvgViewsColumnCellProps) {
  return <div className="text-muted-foreground font-mono">{formatCompact(averageViews)}</div>;
}
